<script>
    export default {
        name: "ErrorHandler",
        data: function () {
            return {
                error: {}
            }
        },
        methods: {
            handleErrorStatusCode: function (error) {
                if (error.response) {
                    switch (error.response.status) {
                        case 401:
                            break;
                        case 403:
                            break;
                        case 404:
                            break;
                        default:
                            break;
                    }
                } else {
                    this.handleErrorStatusCode(error)
                }
            },
        }
    }
</script>